<template>
  <v-row>
    <v-col cols="12">
      <h2 v-if="title">{{ title }}</h2>
      <span v-if="description" class="subtitle-1">{{ description }}</span>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
    },
  },
});
</script>
